import { Injectable } from '@angular/core';
import { EMPTY, forkJoin } from 'rxjs';
import { Config } from 'app/shared/services/config';
import { HttpClient } from '@angular/common/http';
import { APIBuildNumberResponse, BuildNumbers, UIBuildNumberResponse } from '../models/build-numbers';
import { catchError, map } from 'rxjs/operators';


@Injectable()
export class AboutUsService {
    constructor(public http: HttpClient) {}

    public getBuildNumbers() {
        const uiBuildNumber = this.http.get<UIBuildNumberResponse>(Config.urls.uiBuildNumber);
        const apiBuildNumber = this.http.get<APIBuildNumberResponse>(Config.urls.apiBuildNumber);

        return forkJoin([uiBuildNumber, apiBuildNumber]).pipe(
            map(
                ([uiBuildNumberResponse, apiBuildNumberResponse]) => {
                    const buildNumbers: BuildNumbers = {
                        // check for build number from VSTS
                        ui: uiBuildNumberResponse.build === '#{Build.BuildNumber}#' ? '--' : uiBuildNumberResponse.build,
                        build: apiBuildNumberResponse.build,
                        node: apiBuildNumberResponse.node,
                        region: apiBuildNumberResponse.region,
                    };
                    return buildNumbers;
                }
            ),
            catchError(() => EMPTY)
        );
    }
}
